import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, push, ref, remove, update } from "firebase/database";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../App.css";
import { db } from "../Firebase";
import { validateAadhaar, validatePhone } from "../utils/fieldValidation";
import { maskPhoneNumber } from "../utils/maskingUtils";

const relationOptions = ["मुखिया स्वयं","पत्नी","पुत्र","पुत्री","बहू","सगी बहन","पारिवारिक बहन","सगा भाई","पारिवारिक भाई","दादा","दादी","परदादा","परदादी","चाचा","चाची","बड़े पापा","बड़ी मम्मी","बुआ","फूपा","नाना","नानी","मामा","मामी","मोसी","मोसिया","माँ","पिता","सास","ससुर","नाती","नातिन","पोता","पोती","भतीजा","भतीजी","भांजा","भांजी","देवरानी","जिठानी","देवर","जेठ","सरुभाई","जीजा","भाभी","साला","साली","साराज","दामाद","व्यावहारिक रिश्ता","अन्य"];

const Information = () => {
  const { regId } = useParams();
  const [registrationData, setRegistrationData] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [urbanAreas, setUrbanAreas] = useState([]);
  const [workTypes, setWorkTypes] = useState([]);

  useEffect(() => {
    onValue(ref(db, `registration/${regId}`), snap => {
      if (snap.exists()) setRegistrationData(snap.val());
    });
    const fetchData = (path, setter) =>
      onValue(ref(db, path), snap =>
        setter(snap.exists() ? Object.entries(snap.val()).map(([id, v]) => ({ id, ...v })) : [])
      );
    fetchData("masters/states", setStates);
    fetchData("masters/cities", setCities);
    fetchData("masters/urbanAreas", setUrbanAreas);
    fetchData("masters/workTypes", setWorkTypes);
  }, [regId]);

  const emptyForm = {
    name:"", fatherName:"", gender:"", relation:"", dob:"", aadhaar:"",
    maritalStatus:"", mobile:"", whatsapp:"", email:"", bloodGroup:"",
    currentAddress:"", birthAddress:"", educationStatus:"", educationState:"",
    educationDistrict:"", educationClass:"", educationSubject:"",
    workType:"", workState:"", workDistrict:"", workArea:"",
    workAreaName:"", workDepartment:"", workPosition:"",
  };

  const [form, setForm] = useState(emptyForm);
  const [showModal, setShowModal] = useState(false);
  const [showMemberView, setShowMemberView] = useState(false);
  const [memberViewData, setMemberViewData] = useState(null);
  const [editingMember, setEditingMember] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [requestMessage, setRequestMessage] = useState('');

  const generate7DigitId = () => Math.floor(1000000 + Math.random() * 9000000).toString();

  const handlePrint = () => {
    const members = registrationData?.members ? Object.values(registrationData.members) : [];
    const b = registrationData?.basic || {};
    const meta = registrationData?.meta || {};

    const calcAge = (dob) => {
      if (!dob) return '-';
      const d = new Date(dob);
      if (isNaN(d)) return '-';
      return Math.floor((Date.now() - d) / (365.25 * 24 * 60 * 60 * 1000));
    };

    const fmtDate = (d) => {
      if (!d) return '-';
      const dt = new Date(d);
      if (isNaN(dt)) return d;
      return dt.toLocaleDateString('hi-IN');
    };

    const regInfoRows = [
      ['परिवार आईडी', regId],
      ['परिवार के मुखिया', b.headName || '-'],
      ['मोबाइल नंबर', b.mobile || '-'],
      ['समाज में प्रचलित नाम', b.displayName || '-'],
      ['कुल सदस्य', b.Totalmember || '-'],
      ['पंजीयन दिनांक', fmtDate(meta.createdAt)],
      ['देश', b.country || 'भारत'],
      ['राज्य', b.state || '-'],
      ['जिला', b.city || '-'],
      ['ब्लॉक', b.block || 'N/A'],
      ['ग्राम पंचायत', b.panchayat || 'N/A'],
      ['ग्राम / शहर', b.gram || b.urbanArea || 'N/A'],
      ['पता विवरण', b.address || '-'],
      ['जाति प्रकार', b.jatiPrakar || '-'],
      ['उपजाति प्रकार', b.upjatiPrakar || '-'],
      ['गोत्र / वंश', b.gotra || '-'],
      ['मूर', b.moor || '-'],
      ['परिवार स्थिति', b.familyType || '-'],
      ['आवास स्थिति', b.houseType || '-'],
      ['संबंधित जैन मंदिर', b.Mandirtype || '-'],
      ['मंदिर से संबंध', b.mandirRelation || '-'],
      ['मातृभाषा', b.language || '-'],
    ].map(([k, v]) => `
      <div class="reg-field">
        <div class="reg-label">${k}</div>
        <div class="reg-value">${v}</div>
      </div>
    `).join('');

    const memberCards = members.map((m, i) => {
      const fields = [
        ['सदस्य आईडी', m.memberId || '-'],
        ['पिता / पति का नाम', m.fatherName || '-'],
        ['लिंग', m.gender || '-'],
        ['मुखिया से संबंध', m.relation || '-'],
        ['जन्मदिनांक', m.dob || '-'],
        ['उम्र', calcAge(m.dob)],
        ['विवाहिक स्थिति', m.maritalStatus || '-'],
        ['आधार नंबर', m.aadhaar || '-'],
        ['ब्लड ग्रुप', m.bloodGroup || '-'],
        ['मोबाइल', m.mobile || '-'],
        ['WhatsApp', m.whatsapp || '-'],
        ['Email', m.email || '-'],
        ['वर्तमान पता', m.currentAddress || '-'],
        ['जन्म स्थान', m.birthAddress || '-'],
        ['शिक्षा स्थिति', m.educationStatus || '-'],
        ['शिक्षा राज्य', m.educationState || '-'],
        ['शिक्षा जिला', m.educationDistrict || '-'],
        ['कक्षा', m.educationClass || '-'],
        ['विषय', m.educationSubject || '-'],
        ['कार्य प्रकार', m.workType || '-'],
        ['कार्य राज्य', m.workState || '-'],
        ['कार्य जिला', m.workDistrict || '-'],
        ['कार्य क्षेत्र', m.workArea || '-'],
        ['विभाग', m.workDepartment || '-'],
        ['पद', m.workPosition || '-'],
      ].map(([k, v]) => `
        <div class="mem-field">
          <div class="mem-label">${k}</div>
          <div class="mem-value">${v}</div>
        </div>
      `).join('');

      return `
        <div class="member-card">
          <div class="member-header">
            <span class="member-num">${i + 1}</span>
            <span class="member-name">${m.name || '-'}</span>
            <span class="member-rel">${m.relation || ''}</span>
          </div>
          <div class="mem-grid">${fields}</div>
        </div>
      `;
    }).join('');

    const w = window.open('', '_blank');
    w.document.write(`
      <!DOCTYPE html><html><head>
      <meta charset="UTF-8">
      <title>जैन कुल परिवार विवरण - ${regId}</title>
      <style>
        @page { size: A4; margin: 12mm; }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: Arial, sans-serif; font-size: 11px; color: #111; background: #fff; }

        /* Header */
        .page-header { text-align: center; border-bottom: 3px solid #1a5276; padding-bottom: 8px; margin-bottom: 12px; }
        .page-header h1 { font-size: 15px; color: #1a5276; font-weight: bold; }
        .page-header h2 { font-size: 11px; color: #555; font-weight: normal; margin-top: 2px; }
        .page-header .report-title { font-size: 13px; color: #c0392b; font-weight: bold; margin-top: 4px; }

        /* Section title */
        .section-title { background: #1a5276; color: #fff; font-size: 11px; font-weight: bold; padding: 4px 8px; margin: 10px 0 6px; border-radius: 2px; }

        /* Registration info grid */
        .reg-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 5px; margin-bottom: 10px; }
        .reg-field { border: 1px solid #ccc; border-radius: 3px; padding: 4px 6px; background: #f9f9f9; }
        .reg-label { font-size: 8.5px; color: #666; margin-bottom: 1px; }
        .reg-value { font-size: 10px; font-weight: bold; color: #111; word-break: break-word; }

        /* Member cards */
        .member-card { border: 1.5px solid #2e86c1; border-radius: 5px; margin-bottom: 10px; page-break-inside: avoid; overflow: hidden; }
        .member-header { background: #2e86c1; color: #fff; padding: 5px 10px; display: flex; align-items: center; gap: 8px; }
        .member-num { background: #fff; color: #2e86c1; font-weight: bold; font-size: 11px; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .member-name { font-size: 12px; font-weight: bold; flex: 1; }
        .member-rel { font-size: 10px; background: rgba(255,255,255,0.2); padding: 1px 6px; border-radius: 10px; }
        .mem-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 4px; padding: 6px; background: #fff; }
        .mem-field { border: 1px solid #dde; border-radius: 3px; padding: 3px 5px; background: #f4f8ff; }
        .mem-label { font-size: 8px; color: #555; margin-bottom: 1px; }
        .mem-value { font-size: 9.5px; font-weight: bold; color: #111; word-break: break-word; }

        /* Footer */
        .print-footer { text-align: center; font-size: 9px; color: #888; margin-top: 12px; border-top: 1px solid #ccc; padding-top: 5px; }

        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
      </style>
      </head><body>

      <div class="page-header">
        <h1>&#128106; जैन समाज पोर्टल</h1>
        <h2>समग्र सामाजिक सुरक्षा मिशन</h2>
        <div class="report-title">जैन कुल परिवार विवरण रिपोर्ट</div>
      </div>

      <div class="section-title">&#128203; परिवार की मूल जानकारी (Registration ID: ${regId})</div>
      <div class="reg-grid">${regInfoRows}</div>

      <div class="section-title">&#128101; परिवार के सदस्यों की जानकारी</div>
      ${memberCards}

      <div class="print-footer">प्रिंट दिनांक: ${new Date().toLocaleString('hi-IN')} &nbsp;|&nbsp; जैन समाज पोर्टल</div>
      </body></html>
    `);
    w.document.close();
    setTimeout(() => w.print(), 500);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(p => name === "workType" ? { ...p, [name]: value, workArea: "" } : { ...p, [name]: value });
  };

  const handleEditChange = e => {
    const { name, value } = e.target;
    setEditForm(p => name === "workType" ? { ...p, [name]: value, workArea: "" } : { ...p, [name]: value });
  };

  const handleRequestChange = async () => {
    if (!requestMessage.trim()) { alert('कृपया अनुरोध संदेश दर्ज करें'); return; }
    try {
      await push(ref(db, 'changeRequests'), {
        familyId: regId, familyName: registrationData?.basic?.headName,
        mobile: registrationData?.basic?.mobile, message: requestMessage,
        status: 'pending', createdAt: Date.now()
      });
      alert('आपका अनुरोध सफलतापूर्वक भेज दिया गया है ✅');
      setShowRequestModal(false); setRequestMessage('');
    } catch { alert('अनुरोध भेजने में त्रुटि हुई ❌'); }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (registrationData?.meta?.status === 'approved') { alert('यह परिवार अनुमोदित है — नए सदस्य जोड़ना संभव नहीं है।'); return; }
    if (!form.name || !form.mobile || !form.relation) { alert("कृपया नाम, मोबाइल और संबंध भरें"); return; }
    if (!validatePhone(form.mobile)) { alert("मोबाइल नंबर 10 अंकों का होना चाहिए"); return; }
    if (form.aadhaar && !validateAadhaar(form.aadhaar)) { alert("आधार नंबर 12 अंकों का होना चाहिए"); return; }
    try {
      const memberId = generate7DigitId();
      await push(ref(db, `registration/${regId}/members`), {
        memberId, ...form,
        state: registrationData?.basic?.state || '',
        city: registrationData?.basic?.city || '',
        createdAt: Date.now(),
      });
      alert(`सदस्य जोड़ा गया ✅\nMember ID: ${memberId}`);
      setForm(emptyForm); setShowModal(false);
    } catch { alert("सदस्य जोड़ते समय त्रुटि हुई ❌"); }
  };

  const handleUpdateMember = async (e) => {
    e.preventDefault();
    if (!editingMember) return;
    if (!editForm.name || !editForm.mobile || !editForm.relation) { alert("कृपया नाम, मोबाइल और संबंध भरें"); return; }
    if (!validatePhone(editForm.mobile)) { alert("मोबाइल नंबर 10 अंकों का होना चाहिए"); return; }
    if (editForm.aadhaar && !validateAadhaar(editForm.aadhaar)) { alert("आधार नंबर 12 अंकों का होना चाहिए"); return; }
    try {
      await update(ref(db, `registration/${regId}/members/${editingMember}`), {
        ...editForm,
        state: registrationData?.basic?.state || editForm.state,
        city: registrationData?.basic?.city || editForm.city,
        updatedAt: Date.now(),
      });
      alert('सदस्य अपडेट हो गया ✅');
      setShowModal(false); setEditingMember(null); setEditForm({});
    } catch { alert('सदस्य अपडेट करने में त्रुटि हुई ❌'); }
  };

  const handleDeleteMember = async (memberKey) => {
    if (!window.confirm('क्या आप वाकई इस सदस्य को हटाना चाहते हैं?')) return;
    try {
      await remove(ref(db, `registration/${regId}/members/${memberKey}`));
      alert('सदस्य हटा दिया गया ✅');
    } catch { alert('सदस्य हटाने में त्रुटि हुई ❌'); }
  };

  const v = (field) => editingMember ? editForm[field] : form[field];
  const ch = editingMember ? handleEditChange : handleChange;

  const renderMemberForm = () => (
    <div className="row g-3">
      {/* Personal */}
      <div className="col-12"><h6 className="text-primary fw-bold mb-0">👤 व्यक्तिगत जानकारी</h6></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">सदस्य का नाम *</label><input className="form-control" name="name" value={v('name')||''} onChange={ch} required /></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">पिता / पति का नाम</label><input className="form-control" name="fatherName" value={v('fatherName')||''} onChange={ch} /></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">लिंग</label>
        <select className="form-select" name="gender" value={v('gender')||''} onChange={ch}>
          <option value="">चयन करें</option><option>पुरुष</option><option>महिला</option><option>अन्य</option>
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">मुखिया से संबंध *</label>
        <select className="form-select" name="relation" value={v('relation')||''} onChange={ch} required>
          <option value="">चयन करें</option>
          {relationOptions.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">जन्मदिनांक</label><input type="date" className="form-control" name="dob" value={v('dob')||''} onChange={ch} /></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">विवाहिक स्थिति</label>
        <select className="form-select" name="maritalStatus" value={v('maritalStatus')||''} onChange={ch}>
          <option value="">चयन करें</option><option>अविवाहित</option><option>विवाहित</option><option>विधवा/विधुर</option><option>ब्रम्हचर्य आजीवन</option>
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">AADHAR No</label><input className="form-control" name="aadhaar" value={v('aadhaar')||''} onChange={ch} /></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">ब्लड ग्रुप</label>
        <select className="form-select" name="bloodGroup" value={v('bloodGroup')||''} onChange={ch}>
          <option value="">चयन करें</option><option>जानकारी नहीं</option><option>A+</option><option>A-</option><option>B+</option><option>B-</option><option>AB+</option><option>AB-</option><option>O+</option><option>O-</option>
        </select>
      </div>

      {/* Contact */}
      <div className="col-12 mt-2"><h6 className="text-success fw-bold mb-0">📞 संपर्क जानकारी</h6></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">मोबाइल *</label><input className="form-control" name="mobile" value={v('mobile')||''} onChange={ch} required placeholder="मोबाइल नंबर" /></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">WhatsApp No</label><input className="form-control" name="whatsapp" value={v('whatsapp')||''} onChange={ch} /></div>
      <div className="col-12"><label className="form-label fw-semibold">Email ID</label><input type="email" className="form-control" name="email" value={v('email')||''} onChange={ch} /></div>

      {/* Address */}
      <div className="col-12 mt-2"><h6 className="text-warning fw-bold mb-0">🏠 पता जानकारी</h6></div>
      <div className="col-12"><label className="form-label fw-semibold">वर्त्तमान पता</label><input className="form-control" name="currentAddress" value={v('currentAddress')||''} onChange={ch} /></div>
      <div className="col-12"><label className="form-label fw-semibold">जन्म स्थान का पता</label><input className="form-control" name="birthAddress" value={v('birthAddress')||''} onChange={ch} /></div>

      {/* Education */}
      <div className="col-12 mt-2"><h6 className="text-primary fw-bold mb-0">📚 शिक्षा की जानकारी</h6></div>
      <div className="col-12 col-md-4"><label className="form-label fw-semibold">शिक्षा की स्थिति</label>
        <select className="form-select" name="educationStatus" value={v('educationStatus')||''} onChange={ch}>
          <option value="">चयन करें</option><option value="Running">Running</option><option value="Complete">Complete</option>
        </select>
      </div>
      <div className="col-12 col-md-4"><label className="form-label fw-semibold">राज्य</label>
        <select className="form-select" name="educationState" value={v('educationState')||''} onChange={ch}>
          <option value="">चयन करें</option>{states.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
        </select>
      </div>
      <div className="col-12 col-md-4"><label className="form-label fw-semibold">जिला</label>
        <select className="form-select" name="educationDistrict" value={v('educationDistrict')||''} onChange={ch}>
          <option value="">चयन करें</option>{cities.filter(c => c.state === v('educationState')).map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">कक्षा</label><input className="form-control" name="educationClass" value={v('educationClass')||''} onChange={ch} placeholder="कक्षा" /></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">विषय</label><input className="form-control" name="educationSubject" value={v('educationSubject')||''} onChange={ch} placeholder="विषय" /></div>

      {/* Work */}
      <div className="col-12 mt-2"><h6 className="text-info fw-bold mb-0">💼 कार्य की जानकारी</h6></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">कार्य का प्रकार</label>
        <select className="form-select" name="workType" value={v('workType')||''} onChange={ch}>
          <option value="">चयन करें</option>{workTypes.map(w => <option key={w.id} value={w.name}>{w.name}</option>)}
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">राज्य</label>
        <select className="form-select" name="workState" value={v('workState')||''} onChange={ch}>
          <option value="">चयन करें</option>{states.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">जिला</label>
        <select className="form-select" name="workDistrict" value={v('workDistrict')||''} onChange={ch}>
          <option value="">चयन करें</option>{cities.filter(c => c.state === v('workState')).map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">क्षेत्र</label>
        <select className="form-select" name="workArea" value={v('workArea')||''} onChange={ch}>
          <option value="">चयन करें</option>{urbanAreas.filter(u => u.city === v('workDistrict')).map(u => <option key={u.id} value={u.name}>{u.name}</option>)}
        </select>
      </div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">विभाग/प्रकार</label><input className="form-control" name="workDepartment" value={v('workDepartment')||''} onChange={ch} placeholder="विभाग/प्रकार" /></div>
      <div className="col-12 col-md-6"><label className="form-label fw-semibold">पद/नाम</label><input className="form-control" name="workPosition" value={v('workPosition')||''} onChange={ch} placeholder="पद/नाम" /></div>
    </div>
  );

  return (
    <div className="container my-3 my-md-5 px-2 px-md-3">
      <div className="card shadow">
        <div className="card-header bg-success text-white fw-bold text-center">
          👨‍👩‍👧‍👦 परिवार की जानकारी
          <div className="mt-2 d-flex justify-content-center align-items-center gap-2 flex-wrap">
            <span className="badge bg-light text-dark">परिवार ID: {regId}</span>
            <button className="btn btn-sm btn-warning" onClick={handlePrint}>🖨️ प्रिंट करें</button>
          </div>
        </div>

        <div className="card-body p-2 p-md-4">
          {/* Family Info */}
          {registrationData?.basic && (
            <div className="row g-2 mb-3">
              {[
                { label: 'मुखिया का नाम', value: registrationData.basic.headName },
                { label: 'मोबाइल', value: registrationData.basic.mobile },
                { label: 'कुल सदस्य', value: registrationData.basic.Totalmember },
                { label: 'राज्य', value: registrationData.basic.state },
                { label: 'शहर', value: registrationData.basic.city },
              ].map(({ label, value }) => (
                <div className="col-6 col-md-4 col-lg-2" key={label}>
                  <div className="card p-2 h-100 border-0 bg-light">
                    <small className="text-muted">{label}</small>
                    <div className="fw-semibold" style={{ fontSize: '0.9rem' }}>{value || '-'}</div>
                  </div>
                </div>
              ))}
              <div className="col-6 col-md-4 col-lg-2 d-flex align-items-center">
                <button className="btn btn-sm btn-outline-primary w-100" onClick={() => window.location.href = `/registration?edit=${regId}`}>
                  ✏️ संपादित करें
                </button>
              </div>
            </div>
          )}

          {/* Members List */}
          {registrationData?.members && (
            <div className="mt-3">
              <h5 className="text-primary mb-3">👥 परिवार के सदस्य</h5>
              <div className="table-responsive">
                <table className="table table-striped table-bordered align-middle" style={{ fontSize: '0.85rem' }}>
                  <thead className="table-dark">
                    <tr>
                      <th>#</th><th>नाम</th><th>संबंध</th><th>मोबाइल</th><th>जन्मदिनांक</th><th>कार्य</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(registrationData.members).map(([key, member], index) => (
                      <tr key={key}>
                        <td>{index + 1}</td>
                        <td>{member.name || '-'}</td>
                        <td>{member.relation || '-'}</td>
                        <td>{member.mobile ? maskPhoneNumber(member.mobile) : '-'}</td>
                        <td>{member.dob || '-'}</td>
                        <td>
                          <div className="d-flex flex-wrap gap-1">
                            <button className="btn btn-sm btn-outline-primary" onClick={() => { setMemberViewData(member); setShowMemberView(true); }}>👁️</button>
                            <button className="btn btn-sm btn-outline-warning" onClick={() => { setEditingMember(key); setEditForm({ ...member }); setShowModal(true); }}>✏️</button>
                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteMember(key)}>🗑️</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Add Member Button */}
          <div className="text-center my-4">
            {registrationData?.meta?.status !== 'approved' ? (
              <button className="btn btn-success btn-lg" onClick={() => { setEditingMember(null); setEditForm({}); setForm(emptyForm); setShowModal(true); }}>
                ➕ परिवार के सदस्य जोड़ें
              </button>
            ) : (
              <div>
                <div className="alert alert-success">✅ यह परिवार अनुमोदित है</div>
                <button className="btn btn-warning btn-lg" onClick={() => setShowRequestModal(true)}>📝 परिवर्तन का अनुरोध करें</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* View Member Modal */}
      {showMemberView && memberViewData && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-info text-white">
                <h5 className="modal-title">👤 सदस्य विवरण - {memberViewData.name}</h5>
                <button className="btn-close" onClick={() => setShowMemberView(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  {[
                    ['सदस्य का नाम', memberViewData.name], ['पिता/पति का नाम', memberViewData.fatherName],
                    ['लिंग', memberViewData.gender], ['मुखिया से संबंध', memberViewData.relation],
                    ['जन्मदिनांक', memberViewData.dob], ['विवाहिक स्थिति', memberViewData.maritalStatus],
                    ['AADHAR No', memberViewData.aadhaar], ['ब्लड ग्रुप', memberViewData.bloodGroup],
                    ['मोबाइल', memberViewData.mobile], ['WhatsApp', memberViewData.whatsapp],
                    ['Email', memberViewData.email], ['वर्त्तमान पता', memberViewData.currentAddress],
                    ['जन्म स्थान', memberViewData.birthAddress], ['शिक्षा स्थिति', memberViewData.educationStatus],
                    ['शिक्षा राज्य', memberViewData.educationState], ['शिक्षा जिला', memberViewData.educationDistrict],
                    ['कक्षा', memberViewData.educationClass], ['विषय', memberViewData.educationSubject],
                    ['कार्य प्रकार', memberViewData.workType], ['कार्य राज्य', memberViewData.workState],
                    ['कार्य जिला', memberViewData.workDistrict], ['कार्य क्षेत्र', memberViewData.workArea],
                    ['विभाग', memberViewData.workDepartment], ['पद', memberViewData.workPosition],
                  ].map(([label, value]) => (
                    <div className="col-6 col-md-4" key={label}>
                      <div className="bg-light rounded p-2 h-100">
                        <small className="text-muted d-block">{label}</small>
                        <span className="fw-semibold" style={{ fontSize: '0.88rem' }}>{value || '-'}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowMemberView(false)}>बंद करें</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Member Modal */}
      {showModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-success text-white">
                <h5 className="modal-title">{editingMember ? '✏️ सदस्य संपादित करें' : '➕ नया सदस्य जोड़ें'}</h5>
                <button type="button" className="btn-close" onClick={() => { setShowModal(false); setEditingMember(null); setEditForm({}); }}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={editingMember ? handleUpdateMember : handleSave}>
                  {renderMemberForm()}
                  <div className="text-center mt-4 d-flex justify-content-center gap-3 flex-wrap">
                    <button type="submit" className="btn btn-success btn-lg px-5">
                      {editingMember ? '✏️ अपडेट करें' : '➕ जोड़ें'}
                    </button>
                    <button type="button" className="btn btn-secondary btn-lg" onClick={() => { setShowModal(false); setEditingMember(null); setEditForm({}); }}>
                      रद्द करें
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Request Change Modal */}
      {showRequestModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-warning">
                <h5 className="modal-title">📝 परिवर्तन का अनुरोध</h5>
                <button className="btn-close" onClick={() => setShowRequestModal(false)}></button>
              </div>
              <div className="modal-body">
                <p><strong>परिवार ID:</strong> {regId}</p>
                <p><strong>मुखिया:</strong> {registrationData?.basic?.headName}</p>
                <div className="mb-3">
                  <label className="form-label">आप क्या बदलना चाहते हैं? <span className="text-danger">*</span></label>
                  <textarea className="form-control" rows="4" value={requestMessage} onChange={e => setRequestMessage(e.target.value)} placeholder="कृपया विस्तार से बताएं..."></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRequestModal(false)}>रद्द करें</button>
                <button className="btn btn-warning" onClick={handleRequestChange}>अनुरोध भेजें</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Information;
